import { BaseLayout } from "@components/general/base_layout";
import { Header } from "@components/general/header";
import { useThemeStore } from "@stores/theme.store";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";

export const SchoolPage = () => {
  const { setBottomNavigation } = useThemeStore((state) => state);

  useEffect(() => {
    setBottomNavigation("hidden");
  }, [setBottomNavigation]);
  return (
    <>
      <BaseLayout>
        <Header />

        <Outlet />
      </BaseLayout>
    </>
  );
};
